import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import React, { useEffect, useRef, useState } from 'react'
import LaboUploadAdapter from './LaboUploadAdapter'

// const ClassicEditor = require("@ckeditor/custom-build/build/ckeditor");

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new LaboUploadAdapter(loader)
  }
}

function CkEditor5Formik({ formik, name, ...props }) {
  const editorRef = useRef()
  const [editor, setEditor] = useState(null)
    const editorInstanceRef = useRef(null)

  useEffect(() => {
    if (editor) {
      if (editor.getData() === '') editor.setData(formik.values[name])
    }
  }, [formik.values[name]])

  useEffect(() => {
    let isMounted = true

    ClassicEditor.create(editorRef.current, {
      toolbar: {
        items: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          '|',
          'indent',
          'outdent',
          '|',
          'MathType',
          'ChemType',
          'specialCharacters',
          '|',
          'imageUpload',
          'blockQuote',
          'insertTable',
          'mediaEmbed',
          'undo',
          'redo',
        ],
      },
      language: 'en',
      heading: {
        options: [
          { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
          { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
          { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
          { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
          { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
          { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
          { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
        ],
      },
      image: {
        toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
      },
      licenseKey: '',
      extraPlugins: [MyCustomUploadAdapterPlugin],
    })
      .then((editor) => {
        if (!isMounted) {
          editor.destroy()
          return
        }
        setEditor(editor)
        editorInstanceRef.current = editor
        const initialData = formik.values[name] || ''
        editor.setData(initialData)
        console.log(editor)
        editor.model.document.on('change:data', () => {
          formik.setFieldValue(name, editor.getData())
        })
      })
      .catch((error) => {
        console.error(error)
      })
      return () => {
        isMounted = false
  
        if (editorInstanceRef.current) {
          editorInstanceRef.current.destroy().catch(() => {})
          editorInstanceRef.current = null
        }
      }
  }, [])

  return <div ref={editorRef}></div>
}

CkEditor5Formik.propTypes = {}

export default CkEditor5Formik
